import Vue from 'vue'
import LoadingVue from './Loading.vue'
const LoadingToastConstructor = Vue.extend(LoadingVue)
let instance

const _initInstance = () => {
  if (instance && instance._LOADINGTOAST_) {
    return instance
  }
  instance = new LoadingToastConstructor({
    el: document.createElement('div')
  })
  instance._LOADINGTOAST_ = true
}

const _initData = options => {
  instance.duration = options.duration || 3000
}

const LoadingToast = (options = {}) => {
  _initInstance()
  _initData(options)

  if (!instance._MOUNTED_) {
    document.body.appendChild(instance.$el)
    instance._MOUNTED_ = true
  }
  instance.show = true
}

LoadingToast.show = (options = {}) => {
  if (instance && instance._LOADINGTOAST_) {
    instance.show = true
  } else {
    LoadingToast(options)
  }
}

LoadingToast.autoLoading = (options = {}, callback) => {
  LoadingToast(options)
  instance.delayHide(callback)
}

LoadingToast.hide = () => {
  if (instance && instance._LOADINGTOAST_) {
    instance.show = false
  }
}

LoadingToast.destroy = () => {
  if (instance && instance._LOADINGTOAST_) {
    if (instance._MOUNTED_) {
      const parentNode = instance.$el.parentNode
      parentNode.removeChild(instance.$el)
    }
    instance = null
  }
}

// eslint-disable-next-line import/no-default-export
export default LoadingToast
